// extracted by mini-css-extract-plugin
module.exports = {"setup_code":"twoFactorAuthenticationSetting_setup_code__OSiEq","securityCode":"twoFactorAuthenticationSetting_securityCode__2ZRWb"};